/* eslint-disable */
import React, {useEffect,useState} from 'react'
import UserTable from 'components/UserTable'
import AdminUserTable from 'components/AdminUserTable'
import { history } from 'redux/store'
import { connect, useDispatch } from 'react-redux'
import { Breadcrumb, Button, Input, Dropdown, Menu, Space, Row, Col, Table, Switch, message, Spin, Modal } from 'antd'
import { SearchOutlined, CaretDownOutlined, AlignLeftOutlined, PlusCircleOutlined} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { getAccount, designateAdmin, changeAccountStatus, logout } from 'api/hub'
import { useTranslation } from 'react-i18next'

//資料來源

const { Search } = Input;


const AccountSetting = (props) => {
  const url = new URL(window.location.href)
  const urlParams = url.searchParams
  const searchValue = urlParams.get('search')?urlParams.get('search'):""
  const filterValue = urlParams.get('filter')?urlParams.get('filter')==='false' ? false:true :false
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [data, setData] = useState([])
  const [admin, setAdmin] = useState(null)
  const [search, setSearch] = useState(searchValue)
  const [stateText, setStateText] = useState(filterValue)
  const [loading, setLoading] = useState(false)

  const getData = ()=>{
    setLoading(true)
    dispatch(getAccount({
      "nick_name": search,
      "account": search,
      "include_suspended": !stateText,
      "tenant_id": JSON.parse(localStorage.getItem('LoginInfo')).tenantId,
      "operator_id": JSON.parse(localStorage.getItem('LoginInfo')).operator_id
    })).then((res)=>{
      setLoading(false)
      if(res.data){
        for (var i = 0; i < res.data.length; i++) {
          res.data[i]['number']='00'+parseInt(i + 1)
          res.data[i]['key']=i
      }
      setData(res.data)
     }else{
      setData([])
     }
    }
    )
  }
  useEffect(()=>{
    if(JSON.parse(localStorage.getItem('LoginInfo')).accountType !== "admin"){
      history.push(
        { pathname:`/portal/account/setting/user`
        }
      )
    }else{
      getData()
    }

    },[])
  const columns = [
    {
      title: t('Account.Setting.No'),
      dataIndex: 'number',
      key: 'number',
      render:(item,record)=>{
        return <div onClick={() =>handleonClick(record)}>{item}</div>
      },
      align:'center'
    },
    {
      title: t('Account.Setting.Nickname'),
      dataIndex: 'nick_name',
      key: 'nick_name',
      render: (item,record)=>{
        return <Link to={
          { pathname:`/portal/account/setting/${record.number}?search=${search}&filter=${stateText}`,
            state: record
          }} 
          style={{'color':'#7DB926'}}
          >{item}</Link>
      }
    },
    {
      title: t('Account.Setting.Account'),
      dataIndex: 'account',
      key: 'account',
      render:(item,record)=>{
        return <div onClick={() =>handleonClick(record)}>{item}</div>
      }
    },
    {
      title: t('Account.Setting.Status'),
      dataIndex: 'status',
      key: 'status',
      width: '30%',
      render: (item,record)=>{
        return <Switch checkedChildren={t('Account.Setting.Activated')} unCheckedChildren={t('Account.Setting.Suspended')} checked={item === "active"} onClick={(e)=>{onChangeState(e,record)}} />
      },
      align:'center'
    }
  ];
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log('selectedRows: ', selectedRows);
      setAdmin(selectedRows[0])
    },
  };
  const handleonClick = (record) => {
    history.push(
      { pathname:`/portal/account/setting/${record.number}?search=${search}&filter=${stateText}`,
      state: record
      }
      )
  }
  const menu = (
    <Menu>
      <Menu.Item key="0">
        <a onClick={()=>filter(false)}>
          {t('Account.Setting.Activated')}
        </a>
      </Menu.Item>
      <Menu.Item key="1">
        <a onClick={()=>filter(true)}>
          {t('Account.Setting.All')}
        </a>
      </Menu.Item>
    </Menu>
  );
  const onClickAdmin =()=>{
    if(admin != null){
      setLoading(true)
      dispatch(designateAdmin({
        "tenant_id": JSON.parse(localStorage.getItem('LoginInfo')).tenantId,
        "account_id": admin.account_id,
        "operator_id": JSON.parse(localStorage.getItem('LoginInfo')).operator_id
      })).then(res=>{
        setLoading(false)
        if (res.code !== 200){
          // message.error({
          //   content:res.messages[0].tw,
          //   className:"popupmessage"
          // })
        }else{
          message.success({
            content:t('Account.Success'),
            className:"popupmessage"
          })
          Modal.info({
            title: t('Password.PleaseSign'),
            content: '',
            className:'green',
            okText: t('Account.Confirm'),
            onOk:()=>{
              setLoading(true)
              dispatch(logout({
                "access_token": JSON.parse(localStorage.getItem('LoginInfo')).accessToken
              })).then(res=>{
                console.log(res)
                // if(res.code === 200) {
                //   localStorage.clear()
                //   window.location.href='/'
                // }
                localStorage.removeItem('LoginInfo')
                localStorage.removeItem('refresh_token')
                window.location.href='/'
              })
            }
          });
        }
      })
    }

  }
  const filter = (bool) =>{
    setLoading(true)
    history.push(`/portal/account/setting?search=${search}&filter=${!bool}`)
    setStateText(!bool)
    dispatch(getAccount({
      "nick_name": search,
      "account": search,
      "include_suspended": bool,
      "tenant_id": JSON.parse(localStorage.getItem('LoginInfo')).tenantId,
      "operator_id": JSON.parse(localStorage.getItem('LoginInfo')).operator_id
    })).then((res)=>{
      setLoading(false)
      if(res.data){
      for (var i = 0; i < res.data.length; i++) {
        res.data[i]['number']='00'+parseInt(i + 1)
        res.data[i]['key']=i
      }
      setData(res.data)
    }else{
      setData([])
    }
    }
    )
  }
  const onSearch = (value)=>{
    setLoading(true)
    history.push(`/portal/account/setting?search=${value}&filter=${stateText}`)
    setSearch(value)
    dispatch(getAccount({
      "nick_name": value,
      "account": value,
      "include_suspended": !stateText,
      "tenant_id": JSON.parse(localStorage.getItem('LoginInfo')).tenantId,
      "operator_id": JSON.parse(localStorage.getItem('LoginInfo')).operator_id
    })).then((res)=>{
      setLoading(false)
      if(res.data){
        for (var i = 0; i < res.data.length; i++) {
          res.data[i]['number']='00'+parseInt(i + 1)
          res.data[i]['key']=i
        }
        setData(res.data)
      }else{
        setData([])
      }
    }
    )
  }
  const onChangeState = (e,state) =>{
    console.log(e,state)
    dispatch(changeAccountStatus(
      { 
        "nick_name": "",
        "tenant_id": JSON.parse(localStorage.getItem('LoginInfo')).tenantId,
        "account_id": state.account_id,
        "status": state.status ==="active"? "suspended":"active",
        "operator_id": JSON.parse(localStorage.getItem('LoginInfo')).operator_id
      }
    )).then((res)=>{
      // if (res.code !== 200){
      //   message.error({
      //     content:res.messages[0].tw,
      //     className:"popupmessage"
      //   })
      // }
      getData()
    })
  }
return(
  
  <>
    <div className='innerlayout' style={{padding: "36px 0 0 130px"}}>
    <Spin tip={t('Global.Loading')} spinning={loading} style={{padding: '36px 0 0 130px'}} >
        <Breadcrumb separator=">">
          <Breadcrumb.Item>WiAdvance App Market</Breadcrumb.Item>
          <Breadcrumb.Item>{t('Global.member_center')}</Breadcrumb.Item>
          <Breadcrumb.Item className='lastchild'>{t('Menu.manage_users')}</Breadcrumb.Item>
        </Breadcrumb>
      <div className='headtitle'>
        {t('Menu.manage_users')}
      </div>
      <div className='searchbar'>
        <span className='dropdown'> 
        
        <Dropdown overlay={menu} trigger={['click']}>
          <a onClick={(e) => e.preventDefault()}>
            <Space style={{'color':'#7C7C7C'}}>
              <AlignLeftOutlined />
                {stateText ? t('Account.Setting.Activated'):t('Account.Setting.All')}
              <CaretDownOutlined />
            </Space>
          </a>
        </Dropdown>
        </span>
        <div className='mid'>
          <Search
            onSearch={onSearch}
            value={search}
            onChange={(text)=>setSearch(text.target.value)}
            enterButton={t('Account.Setting.Search')}
            allowClear
            size="large"
            placeholder={t('Account.Setting.SearchNickname')}
            prefix={<SearchOutlined className="site-form-item-icon" />}
          />
        </div>
        <span ><Button className='clear' onClick={()=>setSearch('')}>{t('Account.Setting.Clear')}</Button></span>
      </div>
      <div className='searchbar'>
        <Row>
          <Col span={12}>
           <div><Button className='button' onClick={()=>history.push('/portal/account/add')}>{t('Account.Setting.Add')}<PlusCircleOutlined /></Button><Button className='button' onClick={()=>onClickAdmin()}>{t('Account.Setting.SetAdmin')}</Button> </div>
          </Col>
          <Col span={12}>
            <div style={{'textAlign':'end','margin':'30px','color':'#7C7C7C'}}>{t('Account.Setting.Total')} {data? data.length : 0} {t('Account.Setting.DataRecords')}，{t('Account.Setting.shownPage')} 10 <CaretDownOutlined />{t('Account.Setting.records')}</div>
          </Col>
        </Row>
       
       
      </div>
      
      <div className='table'>
        <Table 
          rowSelection={{
            type: 'radio',
            ...rowSelection,
          }}
          columns = {columns} 
          dataSource = {data} 
        />
      </div>
      </Spin>
  </div>
  </>
  )
}
const mapStateToProps = store => (
  { LoginInfo: store.LoginInfo }
)
export default connect(mapStateToProps, null)(AccountSetting)